import type { ComponentProps } from 'react';
import { mcl } from 'utils/class-names';

type SkeletonProps = ComponentProps<'div'>;

export function Skeleton({ className, ...props }: SkeletonProps) {
  return <div className={mcl('animate-pulse bg-neutral-inverted/10', className)} {...props} />;
}
